import React from "react";
import { Card } from "../modules/Settings/Analytes";

export function AnalytesCardPage(props) {
  return <Card {...props} />;
}
